import type { ApiSearchObject } from '@/lib/api/types';

/**
 * Get the slug for a search object, falling back to objectId.
 * Prefers data.slug when available.
 */
function getObjectSlug(result: ApiSearchObject): string | number {
  const slug = (result.data as Record<string, unknown>)?.slug;
  if (slug && typeof slug === 'string') return slug;
  return result.objectId;
}

/**
 * Get the navigation URL for a search object based on its type.
 * Uses the available slug over the numeric ID when possible.
 */
export function getSearchObjectUrl(result: ApiSearchObject): string {
  const slug = getObjectSlug(result);

  switch (result.objectType) {
    case 'item':
      return `/items/${slug}`;
    case 'entity':
      return `/entities/${slug}`;
    case 'initiative':
      return `/initiatives/${slug}`;
    default:
      return '#';
  }
}
